module.exports = __webpack_public_path__ + "img/brands-stripe.3d63cb56.svg";